import React from "react"
import { Link, Outlet } from "react-router-dom"

import styles from "./styles.module.scss"
import Logo from "../../../components/logo"

const AuthLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.loginPage}>
      <div className={styles.mainContent}>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export const Header: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <header>
      <Link to="/">
        <Logo />
      </Link>
      <h1 className="headline-heavy">{children}</h1>
    </header>
  )
}

export const Subtitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <p className={`${styles.subTitle} body`}>{children}</p>
}

export default AuthLayout
